// One source of truth for Vikas's profiles: footer links, home page icons and the Person JSON-LD
// `sameAs` all read from here. sameAs is what search engines and LLMs use to tie the site,
// the person and the accounts together as one entity, so a profile missing here is a profile that
// does not count towards that identity.
export const VIKAS_SOCIALS = [
  { label: 'LinkedIn', icon: 'linkedin', href: 'https://www.linkedin.com/in/vikasdgoel/', handle: 'vikasdgoel' },
  { label: 'X / Twitter', icon: 'x', href: 'https://x.com/Vikasifications', handle: '@Vikasifications' },
  { label: 'Instagram', icon: 'instagram', href: 'https://www.instagram.com/vikasifications/', handle: '@vikasifications' },
  { label: 'YouTube', icon: 'youtube', href: 'https://www.youtube.com/@vikasifications_yt', handle: '@vikasifications_yt' },
  { label: 'Threads', icon: 'threads', href: 'https://www.threads.com/@vikasifications', handle: '@vikasifications' },
];

export const VIKAS_SAME_AS = VIKAS_SOCIALS.map((s) => s.href);
